import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n";

export default function NotFound() {
  const { t, locale } = useI18n();

  return (
    <div className="pt-24 pb-16 min-h-[60vh] flex items-center justify-center">
      <div className="container text-center">
        <h1
          className="text-6xl mb-4"
          style={{ fontFamily: "var(--font-display)", color: "var(--color-charcoal)" }}
        >
          404
        </h1>
        <p className="text-lg mb-8" style={{ color: "var(--color-text-muted)" }}>
          {locale === "it" ? "Pagina non trovata" : "Page not found"}
        </p>
        <Link to="/" className="btn-primary">
          {t.common.backToHome} <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
